export default __webpack_public_path__ + "static/media/added.91e0c718.svg";